<template>
    <div class="mt-6">
        <b-row>
            <b-col col lg="6">
                <b-card>
                    <b-row class="d-flex justify-content-between">
                        <div role="group" class="form-group text-label" style="float: left; width: 100%;">
                            <b-row>
                                <div class="col-3">
                                    <label style="font-weight: bold;font-size: 15px" id="titularReceita">
                                        Titular da Receita:
                                    </label>
                                </div>
                                <div class="col-5">
                                    <b-form-checkbox-group v-model="titularReceita" name="radio-titularReceita"
                                        style="font-size: 15px">
                                        <b-row>
                                            <b-form-checkbox @change="check()" value=0>FEPGE</b-form-checkbox>
                                            <b-form-checkbox @change="check()" value=1>CES</b-form-checkbox>
                                        </b-row>
                                    </b-form-checkbox-group>
                                </div>
                                <div class="col-4">
                                    <b-button class="ml-2" variant="outline-success"
                                        :disabled="!obrigatorios || !podePesquisar" @click="exportarCSVRequisicao"
                                        style="font-size: 15px">
                                        <i class="fa fa-table"></i> Exportar CSV
                                    </b-button>
                                </div>
                            </b-row>
                        </div>
                    </b-row>
                    <b-row class="d-flex justify-content-between mt-4">
                        <div role="group" class="form-group text-label" style="float: left;">
                            <b-row class="mb-4">
                                <div class="col-3">
                                    <label style="font-weight: bold;font-size: 15px" id="emitidas">
                                        Emitidas (por período):
                                    </label>
                                </div>
                                <div class="col-7 px-1">
                                    <b-form-group>
                                        <b-row>
                                            <div class="mx-1">
                                                <vue-monthly-picker
                                                    @selected="check"
                                                    v-model="dataMonitoramentoInicial"
                                                    dateFormat="MM/YYYY"
                                                    :monthLabels="monthlyLabels"
                                                    id="dataInicio" :max="maxDate" name="dataInicio" 
                                                    class="vue-picker"
                                                    :class="!validations.dataInicio.valid || !validations.dataInicio.pastDate || validations.dataInicio.greaterThan ? 'is-invalid' : ''">
                                                </vue-monthly-picker>  
                                            </div>
                                            <div class="mx-1">
                                                <vue-monthly-picker
                                                    id="dataFim"
                                                    class="vue-picker"
                                                    v-model="dataMonitoramentoFinal"
                                                    dateFormat="MM/YYYY"
                                                    @selected="check"
                                                    :monthLabels="monthlyLabels"
                                                    :class="!validations.dataFim.valid || !validations.dataFim.pastDate ? 'is-invalid' : ''"
                                                    :min="dataMinima"
                                                    name="dataFim">
                                                </vue-monthly-picker>
                                            </div>  
                                        </b-row>
                                        <div v-if="!validations.dataInicio.valid" class="invalid-message">A data inserida é
                                            inválida!</div>
                                        <div v-if="!validations.dataInicio.pastDate" class="invalid-message">A data inserida
                                            é maior que a data atual.</div>
                                        <div v-if="validations.dataInicio.greaterThan" class="invalid-message">A data
                                            inicial é maior que a data final.</div>
                                        <div v-if="!validations.dataFim.valid" class="invalid-message">A data inserida é
                                            inválida!</div>
                                        <div v-if="!validations.dataFim.pastDate" class="invalid-message">A data inserida é
                                            maior que a data atual.</div>
                                    </b-form-group>
                                </div>
                                <div class="col-1">
                                    <b-button @click="consultar" variant="primary"
                                        :disabled="!obrigatorios || !podePesquisar">
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </div>
                            </b-row>
                        </div>
                    </b-row>

                    <b-row class="d-flex justify-content-between" v-if="podeExibir">
                        <table style="width:100%" class="espaco-celula">
                            <caption style="color:transparent">Tabela com resultados das requisições</caption>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-center">À Vista</th>
                                    <th class="text-center">Parcelado</th>
                                    <th class="text-center">Total</th>
                                    <th class="text-center">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in requisicoes" :key="item.statusNome">
                                    <td :style="{ color: item.statusCor }">
                                        {{ item.statusNome }}:
                                    </td>
                                    <td class="border text-center p-2 rounded">
                                        {{ item.totalAvista }}
                                    </td>
                                    <td class="border text-center rounded">
                                        {{ item.totalParcelado }}
                                    </td>
                                    <td class="border text-center rounded">
                                        {{ item.total }}
                                    </td>
                                    <td class="border text-center rounded">
                                        R$ {{ item.valor | currency }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr style="font-weight: bold;">
                                    <td>Total</td>
                                    <td class="border text-center rounded">
                                        {{ this.avista }}
                                    </td>
                                    <td class="border text-center realizadas rounded">
                                        {{ this.parcelado }}
                                    </td>
                                    <td class="border text-center frustradas rounded">
                                        {{ this.totalGeral }}
                                    </td>
                                    <td class="border text-center frustradas rounded">
                                        R$ {{ this.valor | currency }}
                                    </td>
                                </tr>
                            </tfoot>

                        </table>
                    </b-row>

                </b-card>
            </b-col>
            <b-col col lg="6">
                <b-card>
                    <div class="ml-2">
                        <b-form-group id="radioGraficoRequisicaoForm">
                            <b-form-radio-group
                                id="radioGraficoRequisicao"
                                v-model="selecionado"
                                :options="options"
                                name="graficoRadio"
                                :checked="selecionado"
                                @change="criarGraficoSelecionado($event)" />
                        </b-form-group>
                    </div>
                    <div class="ml-2">
                        <div id="grafico2"></div>
                    </div>
                </b-card>
            </b-col>

        </b-row>
        <CompLoading ref="loading"></CompLoading>
    </div>
</template>

<script>
import axios from 'axios';
import formatarMixins from '../../../mixins/formatarMixins';
import ApexCharts from 'apexcharts'
import CompLoading from "../../shared/components/CompLoading";
import VueMonthlyPicker from 'vue-monthly-picker'
import moment from 'moment'

export default {
    props: ['loading'],
    components: { CompLoading, VueMonthlyPicker},
    mixins: [formatarMixins],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.$emit('consultar');
        },
        dataMonitoramentoInicial() {
            if (this.dataMonitoramentoInicial) {
                this.dataInicio = moment(this.dataMonitoramentoInicial, 'YYYY-MM-dd').format();
            } else {
                this.dataInicio = null;
            }
        },
        dataMonitoramentoFinal() {
            if (this.dataMonitoramentoFinal) {
                this.dataFim = moment(this.dataMonitoramentoFinal).format('YYYY-MM-') 
                             + moment(this.dataMonitoramentoFinal).endOf('month').date();
            } else {
                this.dataFim = null;
            }
        }
    },
    data() {
        return {
            urlApi: null,
            token: null,
            maxDate: null,
            minDate: null,
            titularReceita: [],
            dataInicio: null,
            dataFim: null,
            itemsRequisicao: [],
            validations: {
                dataInicio: { valid: true, pastDate: true, greaterThan: false },
                dataFim: { valid: true, pastDate: true }
            },
            parcelados: [],
            avistas: [],
            valorParcelados: [],
            valorAvistas:[],
            parcelado: 0,
            avista: 0,
            dataGrafico: [],
            valor: 0,
            totalGeral: 0,
            requisicoes: [],
            chart: null,
            podeExibir: false,
            podePesquisar: false,
            selecionado: 1,
            options:[
                { text: 'Quantidade', value: 1 },
                { text: 'Valor', value: 2 }
            ],
            monthlyLabels: [
                'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez' 
            ],
            dataMonitoramentoInicial: null,
            dataMonitoramentoFinal: null,
            obrigatorios: false
        }
    },
    computed: {
        getTheme() {
            return this.$store.getters.getTheme
        },
        dataMinima() {
            let minDate = null;
            if (this.dataInicio) {
                moment(this.dataInicio).isBefore(this.dataFim);
                minDate = moment(this.dataInicio)
            }
            return minDate;
        }
    },
    methods: {
        check() {
            this.$nextTick(() => {
                this.obrigatorios = this.titularReceita.length > 0 && this.dataInicio && this.dataFim;
                this.verificarDataInicioEFim();
            });
        },

        criarGraficoSelecionado(selecionado){
            this.selecionado = selecionado;
            if (this.chart !== null) {
                    this.chart.destroy();
            }
            if(selecionado == 1){
                this.createChart(this.avistas, this.parcelados, this.dataGrafico);
            } else {
                this.createChart(this.valorAvistas, this.valorParcelados, this.dataGrafico);
            }
            
        },

        verificarDataInicioEFim() {
            if (this.dataInicio && this.dataFim) {
                if (this.dataInicio > this.dataFim) {
                    this.validations.dataInicio.greaterThan = true;
                    this.podePesquisar = false;
                } else {
                    this.validations.dataInicio.greaterThan = false;
                    this.podePesquisar = true;
                }
            } else {
                this.validations.dataInicio.greaterThan = false;
                this.podePesquisar = false;
            }
        },
        createChart(avistas, parcelados, datas) {
            const options = {
                series: [
                    {
                        name: 'À Vista',
                        data: avistas
                    },
                    {
                        name: 'Parcelados',
                        data: parcelados
                    }
                ],
                chart: {
                    id: 'grafico2',
                    type: 'bar',
                    stacked: true
                },
                xaxis: {
                    categories: datas,
                    tickPlacement: true
                },
                colors: ['#008EF9', '#FC4257'],
                plotOptions: {
                    bar: {
                        borderRadius: 5,
                        horizontal: false,
                        dataLabels: {
                            total: {
                                enabled: true,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    formatter: (val) => {
                        return this.formatarValorMonetarioNovo(val); 
                    },
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                legend: {
                    position: 'right',
                    inverseOrder: true
                },
                yaxis: {
                    labels: {
                        formatter: (val) => {
                            return val;
                        }
                    }
                },
            };
            this.chart = new ApexCharts(document.querySelector("#grafico2"), options);
            this.chart.render();
        },

        formatarValorMonetarioNovo(valor) {
            let novoValor = valor;
            if(this.selecionado !== 1){
                if(valor !== null){
                    valor = valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                    });     
                }
                novoValor = valor.replace("R$", "")
            }
            return novoValor;
        },
        async consultar() {
            this.selecionado = 1;
            this.parcelados = [];
            this.avistas = [];
            this.requisicoes = [];
            this.avista = 0;
            this.parcelado = 0;
            this.totalGeral = 0;
            this.valor = 0;
            let body = {
                titularReceita: this.titularReceita,
                dataInicio: this.dataInicio,
                dataFim: this.dataFim
            }
            this.$refs.loading.showLoading();
            axios.post(`${this.urlApi}/v1/painelTesoureiro/consultarRequisicao`, body, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.itemsRequisicao = response.data;

                for (let item in this.itemsRequisicao.requisicao) {
                    let items = this.itemsRequisicao.requisicao[item];
                    this.avista = this.avista + items.totalAvista;
                    this.parcelado = this.parcelado + items.totalParcelado;
                    this.valor = this.valor + items.valor;
                    this.totalGeral = this.totalGeral + items.total;
                    this.requisicoes.push(items);
                }
                this.dataGrafico = this.itemsRequisicao.grafico.map(g => { return g.data });
                this.avistas = this.itemsRequisicao.grafico.map(g => { return g.quantidadeRealizadaAVista });
                this.parcelados = this.itemsRequisicao.grafico.map(g => { return g.quantidadeFrustradaOuParcelada });
                this.valorAvistas = this.itemsRequisicao.grafico.map(g => { return g.valorRealizadaAVista });
                this.valorParcelados = this.itemsRequisicao.grafico.map(g => { return g.valorFrustradaOuParcelada });

                if (this.chart !== null) {
                    this.chart.destroy();
                }
                this.criarGraficoSelecionado(this.selecionado);
                this.podeExibir = true;
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.$refs.loading.hideLoading();
            })
        },
        async exportarCSVRequisicao() {
            this.$refs.loading.showLoading();

            let filtroRequisicao = {
                titularReceita: this.titularReceita,
                dataInicio: this.dataInicio,
                dataFim: this.dataFim

            };

            axios.post(`${this.urlApi}/v1/painelTesoureiro/exportarCsvRequisicao`, filtroRequisicao, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'PainelTesoureiroRequisicoes.csv');
                    document.body.appendChild(link);
                    link.click();
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.selecionado = 1;
        let dataAtual = new Date();
        let ano = dataAtual.getFullYear();
        let mes = dataAtual.getMonth() + 1;
        this.maxDate = ano + "-" + (mes < 10 ? "0" : "") + mes + "-" + (dataAtual.getDate() < 10 ? "0" : "") + dataAtual.getDate();
    }

}
</script>

<style>
.espaco-celula {
    border-collapse: separate;
    border-spacing: 10px;
}
.vue-picker:first-child{
    max-width: 200px !important;
    min-width: 130px !important;
}
.month-picker-wrapper{
    max-width: 200px !important;
    min-width: 130px !important;
}
</style>
